import React from 'react';
import type { TooltipModel } from 'autogen/swagger/all';
import StorageTooltipPopup from './StorageTooltipPopup';

export default function ReviewTranslationDisclaimerTooltip({
    model,
    children
}: {
    model?: TooltipModel;
    children: JSX.Element;
}) {
    if (!model) return children;

    return (
        <StorageTooltipPopup
            name={model.tooltipType}
            size="sm"
            content={{ description: model.content, dismissButtonTitle: model.dismissText }}
            offset={[0, -40]}
            popperOptions={{ modifiers: [{ name: 'flip', enabled: false }] }}
            delay={[2000, 2000]}
        >
            {children}
        </StorageTooltipPopup>
    );
}
